const initialState = {
    version: null,
};

export default (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {

        case 'LAYOUT_SET_VERSION':
            state = {
                ...state,
                version: payload
            };
            return state;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/frontend/store/reducers/layout.js